import type { ChangeEventHandler, FC, ReactElement } from 'react'
import { useState } from 'react'

import { nanoid } from 'nanoid'

import '../form/input.scss'

const Textarea: FC<{
  label: string | ReactElement
  className?: string
  onChange: ChangeEventHandler<HTMLTextAreaElement>
  [k: string]: unknown
}> = ({ label, className, onChange, ...restOfProps }) => {
  const [id] = useState(nanoid())

  return (
    <div className={`textarea-container ${className}`}>
      {label && <label htmlFor={id}>{label}</label>}

      <textarea id={id} onChange={onChange} {...restOfProps} />
    </div>
  )
}

export default Textarea
